"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDotSize = exports.dotSizeTokens = exports.dotOuterContainerStyles = exports.dotCountSize = exports.dotCountPadding = exports.dotCountContent = exports.avatarIconSizeMap = exports.avatarDotSizeMap = void 0;
var _borderRadius = require("./borderRadius");
var _borderWidth = require("./borderWidth");
const avatarIconSizeMap = {
  xxxl: 's',
  xxl: 's',
  xl: 's',
  l: 'xs',
  m: 'xs',
  s: 'xs'
};
exports.avatarIconSizeMap = avatarIconSizeMap;
const avatarDotSizeMap = {
  xxxl: 'm',
  xxl: 'm',
  xl: 'm',
  l: 's',
  m: 'xs',
  s: 'xs'
};
exports.avatarDotSizeMap = avatarDotSizeMap;
const dotOuterContainerStyles = {
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  borderWidth: _borderWidth.borderWidth.button
};
exports.dotOuterContainerStyles = dotOuterContainerStyles;
const dotCountSize = 24;
exports.dotCountSize = dotCountSize;
const dotCountContent = {
  minWidth: dotCountSize,
  height: dotCountSize,
  borderRadius: _borderRadius.borderRadius.roundedLarge
};
exports.dotCountContent = dotCountContent;
const dotCountPadding = {
  paddingTop: 3,
  paddingBottom: 3,
  paddingLeft: 6,
  paddingRight: 6
};

// This works for the purposes of TabNavigation, but it's not stable
// TODO Update this with more stable values
exports.dotCountPadding = dotCountPadding;
const dotSizeTokens = {
  s: 24,
  m: 36,
  l: 42
};
exports.dotSizeTokens = dotSizeTokens;
const getDotSize = count => {
  if (!count || count < 10) return dotSizeTokens.s;
  if (count >= 10) return dotSizeTokens.m;
  if (count >= 100) return dotSizeTokens.l;
  return dotSizeTokens.s;
};
exports.getDotSize = getDotSize;